
import React, { useEffect, useState, useCallback } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { LinesChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
  MarkLineComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { ScatterChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import {
  getTime,
  getDate,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

function SwappingComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();
  let yAxisLength;

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);
  var yAxisData = [];
  var xAxisData = [];
  if (props.data != undefined) {
    props.data.map(function (obj) {
      yAxisData.push(obj.swapCount);
      if (props.selectValue === "HOUR_24" || props.selectValue === "HOUR_12") {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }
    });
  }

  for (var i = 0; i < yAxisData?.length; i++) {
    if (yAxisData[i] > 99 && yAxisData[i] < 1000) {
      yAxisLength = 3;
    } else if (yAxisData[i] > 9 && yAxisData[i] < 100) {
      yAxisLength = 2;
    }
  }

  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  echarts.use([
    TitleComponent,
    TooltipComponent,
    MarkLineComponent,
    UniversalTransition,
    GridComponent,
    LinesChart,
    CanvasRenderer,
    ScatterChart,
  ]);

  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    title: {
      // text: 'Site Status',
    },
    lineStyle: {
      type: "solid",
    },
    legend: {
      show: false,
    },

    grid: {
      top: "20%",
      left: "10%",
      right: "4%",
      bottom: "17%",
      containLabel: true,
      height: "70%",
      show: true,
    },
    xAxis: {
      type: "category",
      axisTick: {
        show: false,
      },
      nameGap: 32,
      name: "Time",
      nameLocation: "middle",
      splitLine: { show: true },
      show: true,
      data: xAxisData,
    },
    yAxis: {
      type: "value",
      name: "Number Of Swap",
      nameLocation: "middle",
      // nameGap: 20,
      splitLine: { show: true },
      nameGap: 30,
      axisLabel: {
        formatter: formatYaxisNumber,
      },
      // min:0,
      // max:500
    },
    series: [
      {
        name: "Time",
        data: yAxisData,
        type: "line",
        symbol: "circle",
        smooth: false,
        color: "#23297a",
        lineStyle: {
          color: "#23297A",
          width: 1.5,
        },
        itemStyle: {
          borderWidth: 0,
          borderColor: "#C4C4C3",
          color: "#23297A",
        },
        symbolSize: 10,
      },
    ],
  });

  return (
    <ReactEcharts
      styles={{ with: "100%", height: "80%" }}
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      opts={{ renderer: "svg" }}
      option={options()}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
    />
  );
}

export default SwappingComponent;
